<template>
    <section class="contactus" section="contactus" id="contactus">
        <h2>Contact Us</h2>
        <div class="contactOptions">
            <div class="contactOption">
                <a id="aMessageUs" href="javascript:void(0)" v-on:click="showContactForm()">
                    <i class="icon-envelope"></i>
                    <h3>Message Us</h3>
                </a>
                <p>Our team will reply within the next business day.</p>
            </div>
            <div class="contactOption">
                <a :href="'tel:' + getPhoneNumber">
                    <i class="icon-phone"></i>
                    <h3>{{$filters.formatPhoneNumber(getPhoneNumber)}}</h3>
                </a>
                <p>Contact our headquarters to speak to a representative.</p>
            </div>
            <div class="contactOption">
                <a href="javascript:void(0)"  v-on:click="showContactForm()">
                    <i class="icon-mvt-chat"></i>
                    <h3>Give Feedback</h3>
                </a>
                <p>Tell us how we can make our service even better.</p>
            </div>
        </div>
    </section>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'contact',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb', 'getPhoneNumber']),
    },
    methods: {
      showContactForm: function() {
          this.$eventBus.$emit('dialog-open-contactus');
      }
    }
};
</script>
<style lang="scss">
@use './contact.scss' as *;
</style>

